var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBecksIconsCmsSandwiches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.4,73.36c.64,0,1.15,.45,1.15,1.02v.68c0,5.88-9.3,8.96-16.68,8.96H26.38c-7.38,0-16.68-3.08-16.68-8.96v-.68c0-.56,.52-1.02,1.15-1.02H109.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.89,63.76c1.64,0,2.97,1.33,2.97,2.97v3.66c0,1.64-1.33,2.97-2.97,2.97H15.36c-1.64,0-2.97-1.33-2.97-2.97v-3.66c0-1.64,1.33-2.97,2.97-2.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.81,56.98H13.44c-1.93,0-3.04-2.54-1.8-4.21,5.49-7.4,25.11-12.88,48.48-12.88s42.99,5.48,48.48,12.88c1.24,1.67,.14,4.21-1.8,4.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.86,40.93c-3.82,1.25-5.42,3.98-6.88,8.31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.77,40.23c-3.82,1.25-7.07,4.68-8.54,9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.02,40.23c-3.82,1.25-7.07,4.68-8.54,9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.13,41.72c-3.66,2.12-4.67,3.75-6.4,7.51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.61,56.98H16.65c-2.57,0-3.97,1.07-3.97,3.1,0,1.67,1.14,3.7,3.97,3.54h9.8l8.04,4.97,8.04-4.97h9.56l8.04,4.97,8.04-4.97h9.56l8.04,4.97,8.04-4.97h9.8c1.6,0,3.97,.11,3.97-3.54,0-3.1-2.37-3.1-3.97-3.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsSandwiches);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_Sandwiches.703faa21.svg";
export { ForwardRef as ReactComponent };